import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 휴가 계획 목록
export const getVacationsPlanList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/plans/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 계획 작성
export const createVacationsPlan = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/plans", body)
      .then((res) => {
        toast.success('휴가계획이 작성되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 계획 상세
export const getVacationsPlan = (planIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/vacations/plans/${planIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 계획 수정
export const modifyVacationsPlan = (planIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/vacations/plans/${planIdx}`, body)
      .then((res) => {
        toast.success('휴가계획이 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 계획 삭제
export const deleteVacationsPlan = (planIdx, employeeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/vacations/plans/${planIdx}`, {
        params: {
          employeeIdx
        }
      })
      .then((res) => {
        toast.success('휴가계획이 삭제되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
